import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=33ef54f5&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=33ef54f5&prod&scoped=true&lang=css"
import style1 from "./Promotion.vue?vue&type=style&index=1&id=33ef54f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef54f5",
  null
  
)

export default component.exports